module.exports = __webpack_public_path__ + "static/media/po-reman-1.c084f46f.png";